"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The GetAdScoreAccessibilityViewResult model module.
 * @module model/GetAdScoreAccessibilityViewResult
 * @version 1.1.3-alpha.1
 */
class GetAdScoreAccessibilityViewResult {
  /**
   * Constructs a new <code>GetAdScoreAccessibilityViewResult</code>.
   * @alias module:model/GetAdScoreAccessibilityViewResult
   */
  constructor() {
    GetAdScoreAccessibilityViewResult.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj) {}

  /**
   * Constructs a <code>GetAdScoreAccessibilityViewResult</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GetAdScoreAccessibilityViewResult} obj Optional instance to populate.
   * @return {module:model/GetAdScoreAccessibilityViewResult} The populated <code>GetAdScoreAccessibilityViewResult</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GetAdScoreAccessibilityViewResult();
      if (data.hasOwnProperty('customer_id')) {
        obj['customer_id'] = _ApiClient.default.convertToType(data['customer_id'], 'String');
      }
      if (data.hasOwnProperty('adscore_id')) {
        obj['adscore_id'] = _ApiClient.default.convertToType(data['adscore_id'], 'String');
      }
      if (data.hasOwnProperty('adscore_visible')) {
        obj['adscore_visible'] = _ApiClient.default.convertToType(data['adscore_visible'], 'Boolean');
      }
      if (data.hasOwnProperty('adscore_visible_without_override')) {
        obj['adscore_visible_without_override'] = _ApiClient.default.convertToType(data['adscore_visible_without_override'], 'Boolean');
      }
      if (data.hasOwnProperty('adscore_unlocked')) {
        obj['adscore_unlocked'] = _ApiClient.default.convertToType(data['adscore_unlocked'], 'Boolean');
      }
      if (data.hasOwnProperty('adscore_unlocked_without_override')) {
        obj['adscore_unlocked_without_override'] = _ApiClient.default.convertToType(data['adscore_unlocked_without_override'], 'Boolean');
      }
      if (data.hasOwnProperty('adscore_visible_by_plan')) {
        obj['adscore_visible_by_plan'] = _ApiClient.default.convertToType(data['adscore_visible_by_plan'], 'Boolean');
      }
      if (data.hasOwnProperty('adscore_visible_by_override')) {
        obj['adscore_visible_by_override'] = _ApiClient.default.convertToType(data['adscore_visible_by_override'], 'Boolean');
      }
      if (data.hasOwnProperty('adscore_unlocked_by_override')) {
        obj['adscore_unlocked_by_override'] = _ApiClient.default.convertToType(data['adscore_unlocked_by_override'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>GetAdScoreAccessibilityViewResult</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GetAdScoreAccessibilityViewResult</code>.
   */
  static validateJSON(data) {
    // ensure the json data is a string
    if (data['customer_id'] && !(typeof data['customer_id'] === 'string' || data['customer_id'] instanceof String)) {
      throw new Error("Expected the field `customer_id` to be a primitive type in the JSON string but got " + data['customer_id']);
    }
    // ensure the json data is a string
    if (data['adscore_id'] && !(typeof data['adscore_id'] === 'string' || data['adscore_id'] instanceof String)) {
      throw new Error("Expected the field `adscore_id` to be a primitive type in the JSON string but got " + data['adscore_id']);
    }
    return true;
  }
}

/**
 * @member {String} customer_id
 */
GetAdScoreAccessibilityViewResult.prototype['customer_id'] = undefined;

/**
 * @member {String} adscore_id
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_id'] = undefined;

/**
 * @member {Boolean} adscore_visible
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_visible'] = undefined;

/**
 * @member {Boolean} adscore_visible_without_override
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_visible_without_override'] = undefined;

/**
 * @member {Boolean} adscore_unlocked
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_unlocked'] = undefined;

/**
 * @member {Boolean} adscore_unlocked_without_override
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_unlocked_without_override'] = undefined;

/**
 * @member {Boolean} adscore_visible_by_plan
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_visible_by_plan'] = undefined;

/**
 * @member {Boolean} adscore_visible_by_override
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_visible_by_override'] = undefined;

/**
 * @member {Boolean} adscore_unlocked_by_override
 */
GetAdScoreAccessibilityViewResult.prototype['adscore_unlocked_by_override'] = undefined;
var _default = exports.default = GetAdScoreAccessibilityViewResult;